import type { LocalStorageModuleDeps } from '~/storage/types'

export interface EmailHtmlCacheLocalStorageDeps
    extends LocalStorageModuleDeps {}

export class EmailHtmlCacheLocalStorageModule {
    constructor(private readonly deps: EmailHtmlCacheLocalStorageDeps) {}

    async getHtml(externalId: string): Promise<string | null> {
        const row = await this.deps.db.emailHtml.get(externalId)
        return row?.html ?? null
    }

    async setHtml(externalId: string, html: string): Promise<void> {
        await this.deps.db.emailHtml.put({
            externalId,
            html,
            updatedAt: Date.now(),
        })
    }

    async deleteHtml(externalId: string): Promise<void> {
        await this.deps.db.emailHtml.delete(externalId)
    }
}
